@let s = pageState();
@if (s.kind === 'pending') {
  <div class="cg-ss-page min-h-screen" aria-busy="true" aria-live="polite">
    <app-marketing-header variant="home" />
    <div class="cg-container--marketing flex flex-col items-center justify-center gap-4 py-24 text-slate-500">
      <span
        class="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700"
        aria-hidden="true"
      ></span>
      <p class="text-sm">Loading…</p>
    </div>
  </div>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1 class="text-xl font-semibold text-slate-800">Testimonials unavailable</h1>
    <p class="mt-3 max-w-lg mx-auto text-slate-600">
      The marketing API did not return testimonials. Ensure the API is running.
    </p>
    <a routerLink="/" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Back to home</a>
  </div>
} @else {
  <div class="cg-ss-page min-h-screen">
    <app-marketing-header variant="home" />

    <app-success-stories-hero
      badge="Student Voices"
      [title]="'All Testimonials'"
      [subtitle]="
        s.page.subtitle ??
        'Browse every published review from students who achieved their global education goals with Career Grad Global.'
      "
      [stats]="heroStats()"
    />

    <app-success-stories-filter-bar
      [activeCategory]="activeCategory()"
      [searchQuery]="searchQuery()"
      (categoryChange)="setCategory($event)"
      (searchChange)="setSearch($event)"
    />

    <main class="cg-ss-main">
      <div class="cg-container--marketing">
        @if (!hasAnyTestimonials()) {
          <p class="cg-ss-grid__empty">No testimonials published yet.</p>
        } @else if (filteredTestimonials().length === 0) {
          <p class="cg-ss-grid__empty">No testimonials match your filters. Try another category or search term.</p>
        } @else {
          <app-success-stories-grid [stories]="visibleTestimonials()" />
          <app-success-stories-load-more
            [hasMore]="hasMore()"
            [loading]="loadingMore()"
            (loadMore)="onLoadMore()"
          />
        }
      </div>
    </main>

    <section class="cg-section" id="cta">
      <div class="cg-container--marketing">
        <app-marketing-consultation-cta sourcePage="/testimonials/all" />
      </div>
    </section>

    <app-marketing-footer />
  </div>
}
